var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{staticClass:"mb-2",attrs:{"cols":"12","sm":_vm.sm,"md":_vm.md}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }